import React, { useEffect, useState, startTransition } from 'react';
import { Helmet } from 'react-helmet-async';
import imagesLoaded from 'imagesloaded';
import { connect } from 'react-redux';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Icon } from "@iconify/react";
//Styling
import styled from "styled-components";

//Import Store
import store from '../../../store';

//Import Action
import { getProducts } from '../../../action/products';
import { cleanFilter, cleanCategory, filterCategories } from '../../../action';

// Import Custom Component
import Breadcrumb from '../../common/breadcrumb';
// import SidebarToggle from '../products/common/sidebars/sidebar-toggle';
// import TopBanner from '../../features/banner/top-banner';
import Pagination from '../../features/pagination';
import GridProduct from './common/grid-product';
import ShopSidebar from './common/shop-sidebar';
import ToolBox from './common/tool-box';
import useViewport from '../../features/useViewport';
import CategoriesMobile from './common/mobile/categories-mobile';
import FiltersMobile from './common/mobile/filters-mobile';
import { removeXSSAttacks, findCategoryPathBySlug } from '../../../utils';
import { useCanonicalLink } from '../../../utils/useCanocialLink';

function FullWidth(props) {
  let params = useParams();
  let location = useLocation();
  const { products, cleanFilter, filter, cleanCategory, filterCategories, categories } = props;
  const { category_slug } = params;
  const [curPage, setCurPage] = useState(1);
  const [layout, setLayout] = useState("grid");
  const [productCount, setProductCount] = useState(0);
  const [displayCount, setDisplayCount] = useState(12);

  const categoryPath = category_slug && categories.length
    ? findCategoryPathBySlug(categories, category_slug)
    : null;

  const crumbs = categoryPath
    ? categoryPath.map((cat) => ({
      name: cat.category_name,
      path: `${process.env.PUBLIC_URL}/produkty/${cat.category_slug}/`,
    }))
    : category_slug
      ? [{
        name: category_slug,
        path: `${process.env.PUBLIC_URL}/produkty/${category_slug}/`,
      }]
      : [];

  const pageTitle = filter.category?.category_name
    ? `${filter.category.category_name} - Buduj.pl`
    : 'Produkty - Buduj.pl';
  const { width } = useViewport();
  const breakpoint = 992;

  useEffect(() => {
    let imgLoad = imagesLoaded(".product-group");

    if (document.querySelector('.skeleton-body.loaded')) {
      document.querySelector('.skeleton-body').classList.remove('loaded');
    }

    imgLoad.on("done", function () {
      if (document.querySelector('.skeleton-body') && productsCatalog.length !== 0) {
        document.querySelector('.skeleton-body').classList.add('loaded');
      }
    });
  });

  const gridType = (layoutParam) => {
    if (layout !== layoutParam) {
      setLayout(layoutParam);
    }
  };

  const onChangeProductCount = (countParam) => {
    if (productCount !== countParam)
      setProductCount(countParam);
  };

  const onChangeCurPage = (curPageParam) => {
    if (curPage !== curPageParam) {
      setCurPage(curPageParam);
    }
  };

  const onChangeDisplayCount = (countParam) => {
    if (displayCount !== countParam) {
      setDisplayCount(countParam);
    }
  };

  const [isLoading, setIsLoading] = useState(true);
  const [productsByCat, setProductsByCat] = useState([]);
  const [productsCatalog, setProductsCatalog] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    if (!products.length) {
      store.dispatch(getProducts());
    }
    cleanFilter();
  }, []);

  useEffect(() => {
    if (category_slug) {
      if (!categories.length) {
        return;
      }

      const path = findCategoryPathBySlug(categories, category_slug);
      if (!path) {
        return;
      }

      const found = path[path.length - 1];
      if (filter.category?.category_id === found.category_id) {
        return;
      }

      filterCategories(found);
      setCurPage(1);
    } else if (filter.category) {
      cleanCategory();
      setCurPage(1);
    }
  }, [category_slug, categories]);

  useEffect(() => {
    startTransition(() => {
      if (filter.category) {
        if (!filter.manufacturer.length) {
          const res = products.filter(f =>
            filter.category && filter.category.category_id === f.category_id ||
            filter.category && filter.category.all_children.some(item => item.category_id === f.category_id) ||
            filter.category && filter.category.all_children.some(child => child.all_children.some(item => item.category_id === f.category_id)));
          setProductsByCat(res);
        }
      } else if (filter.manufacturer.length) {
        const res = productsCatalog.filter(f => filter.manufacturer.includes(f.manufacturer.name));
        setProductsByCat(res);

        if (filter.delivery === "allCountry") {
          const res1 = res.filter(f => f.product_id === 925 || f.product_id === 1133 || f.product_id === 1134);
          setProductsByCat(res1);
        }
      } else if (filter.delivery) {
        if (filter.delivery === "locally") {
          const res = products.filter(f => f);
          setProductsByCat(res);
        } else if (filter.delivery === "allCountry") {
          const res = productsCatalog.filter(f => f.product_id === 925 || f.product_id === 1133 || f.product_id === 1134);
          setProductsByCat(res);
        }
      } else {
        setProductsByCat(products);
      }
    });
  }, [filter.category, filter.manufacturer, filter.delivery, products]);

  useEffect(() => {
    startTransition(() => {
      const hasActiveFilter = filter.category || filter.manufacturer.length || filter.delivery;

      if (hasActiveFilter) {
        setProductsCatalog(productsByCat);
      } else if (productsByCat.length) {
        setProductsCatalog(productsByCat);
      } else {
        setProductsCatalog(products);
      }
    });
  }, [productsByCat, products, filter.category, filter.manufacturer, filter.delivery]);

  useEffect(() => {
    if (productsCatalog.length) {
      setIsLoading(false);
    }
  }, [productsCatalog]);

  const sort = [{ name: 'Popularność', value: 'popularity' }];

  const [openCategories, setOpenCategories] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);

  const handleCategories = () => {
    setOpenFilters(false);
    setOpenCategories(!openCategories);
  };

  const handleFilters = () => {
    setOpenCategories(false);
    setOpenFilters(!openFilters);
  };

  const cleanFilters = (e) => {
    e.preventDefault();
    cleanFilter();
  };

  const canonicalLink = useCanonicalLink();

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <link rel="canonical" href={canonicalLink} />
      </Helmet>

      <div className="main">
        {/* <div className="category-banner-container bg-gray">
          <TopBanner />
        </div> */}

        {
          category_slug ?
            <Breadcrumb crumbs={crumbs} addClass="mb-2" />
            : null
        }

        {width < breakpoint ?
          <>
            <MobileFilters>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-auto">
                    <Link to="#" className={`link ${openCategories ? "active" : ""}`} onClick={(e) => handleCategories()}>Kategorie</Link>
                  </div>
                  <div className="col-auto">
                    <Link to="#" className={`link ${openFilters ? "active" : ""}`} onClick={(e) => handleFilters()}>Filtry</Link>
                  </div>
                </div>
              </div>
            </MobileFilters>
            {
              filter.category || filter.manufacturer.length ? (
                <Filtered>
                  <div className="container">
                    {filter.category ? <Link to={`${process.env.PUBLIC_URL}/produkty`}><Icon icon="iwwa:delete" /> kategoria: {filter.category.category_name}</Link> : ""}
                    {filter.manufacturer.length ? <Link to="#" onClick={(e) => cleanFilters(e)}><Icon icon="iwwa:delete" /> producent: {filter.manufacturer.map(m => m + "; ")}</Link> : ""}
                    {filter.delivery ? <Link to="#" onClick={(e) => cleanFilters(e)}><Icon icon="iwwa:delete" /> dostawa: {filter.delivery === "locally" ? "Lokalnie" : "Cała Polska"}</Link> : ""}
                  </div>
                </Filtered>
              )
                : ""
            }
            {
              openCategories ?
                <CategoriesMobile
                  handleCategories={handleCategories}
                  productsCatalog={productsCatalog}
                />
                : ""
            }
            {
              openFilters ?
                <FiltersMobile
                  handleFilters={handleFilters}
                  productsCatalog={productsCatalog}
                  cleanFilters={cleanFilters}
                  products={products}
                />
                : ""
            }
          </>
          : ""}

        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-9 skeleton-body skel-shop-products">
              <ToolBox
                displayCount={displayCount}
                changeDisplay={onChangeDisplayCount}
                gridType={gridType}
                sort={sort}
              />

              <GridProduct
                curPage={curPage}
                type={layout}
                displayCount={displayCount}
                productCount={onChangeProductCount}
                products={productsCatalog}
                isLoading={isLoading}
              />

              <Pagination
                count={productCount}
                displayCount={displayCount}
                layout={layout}
                changeDisplay={onChangeDisplayCount}
                curPage={onChangeCurPage}
                products={productsCatalog}
              />


              {!!filter?.category?.category_description && (
                <div>
                  <h2>{filter?.category?.category_name || "Brak nazwy kategorii"}</h2>
                  <div dangerouslySetInnerHTML={removeXSSAttacks(filter?.category?.category_description || "")}></div>
                </div>
              )}
            </div>

            {/* <SidebarToggle /> */}

            <aside className="sidebar-shop col-lg-3 order-lg-first mobile-sidebar">
              <ShopSidebar
                productsCatalog={productsCatalog}
                products={products}
              />
            </aside>
          </div>
        </div>

        <div className="mb-5"></div>
      </div>
    </>
  );
}

const MobileFilters = styled.div`
  padding: 1rem 0;
  background-color: #fff;
  border-bottom: 1px solid #c5c5c5;

  .link {
    font-size: 1.7rem;
    color: #002b4f;
    text-transform: uppercase;
    font-weight: 600;

    &.active {
      color: #ff6a00;
    }
  }
`;

const Filtered = styled.div`
  padding: 1.5rem 0;
  background: #fff;
  border-bottom: 1px solid #c5c5c5;

  a {
    background-color: #d3d3d3;
    padding: 2px 8px;
    color: #5d5c5c;
    vertical-align: middle;
    margin-right: 1rem;
    display: inline-block;
    margin-bottom: 1rem;
  }
`;

const mapStateToProps = (state) => {
  return {
    products: state.products.products ? state.products.products : [],
    filter: state.filter ? state.filter : [],
    categories: state.categories.categories ? state.categories.categories : [],
  };
};

export default connect(mapStateToProps, { cleanFilter, cleanCategory, filterCategories })(FullWidth);